<template>
  <div id="JobChance" class="wow fadeIn" data-wow-duration="0.5s">
    <!-- 顶部Banner区域 -->
    <div class="job-banner wow fadeInDown" data-wow-duration="1.2s">
      <div class="banner-content">
        <h1 class="wow fadeIn" data-wow-delay="0.2s">人才招聘</h1>
        <p class="wow fadeIn" data-wow-delay="0.4s">加入我们，成就非凡，携手共创未来</p>
      </div>
    </div>
    
    <div class="container">
      <h1 class="section-title wow fadeInUp" data-wow-duration="1s" style="font-weight: bold;">加入我们</h1>
      <div class="job-intro">
        <p class="intro-text wow fadeInLeft" data-wow-delay="0.2s" data-wow-duration="1s">
          蔚海移动尊重每个人的价值，重视个人专长与发展，我们倡导人人机会平等，为团队中的每位成员提供相应的职业成长路径，并辅以配套的培养计划，帮助您在最短时间内成为专业人士；不同的人才可以沿商务方向、咨询方向、研究方向、职业培训师、公司合伙人等方向获得职业发展。同时，我们也为各校的优秀学生提供宝贵的实习机会，帮忙他们在短时间内快速成长并明确自己的职业发展目标。
        </p>
        <p class="intro-text wow fadeInRight" data-wow-delay="0.4s" data-wow-duration="1s">
          每个人都可以在蔚海移动这一平台上，根据自身的人生规划与特长优势，选择最适合自己的发展道路，努力成长，开创未来！
        </p>
        <p class="contact-info wow bounceIn" data-wow-delay="0.6s" data-wow-duration="1s">
          欢迎自荐！简历可发至邮箱：<a href="cooperation@bluesea-net.com" class="wow pulse" data-wow-delay="1s" data-wow-iteration="3">cooperation@bluesea-net.com</a>
        </p>
      </div>

      <div class="job-list">
        <h2 class="position-title text-center wow fadeInUp" data-wow-delay="0.6s">职位列表</h2>
        <div class="row wow fadeIn" data-wow-delay="0.8s">
          <!-- 职位卡片 -->
          <div class="col-md-3 col-sm-6 col-xs-12" v-for="(job, index) in jobs" :key="job.title">
            <div class="job-item wow flipInY" :data-wow-delay="(0.1 * index + 0.2) + 's'" data-wow-duration="1s" @click="goToDetail(job)">
              <div v-if="job.popular" class="hot-tag wow heartBeat" data-wow-delay="1s" data-wow-iteration="2">热</div>
              <h3 class="wow fadeIn" :data-wow-delay="(0.1 * index + 0.5) + 's'">{{ job.title }}</h3>
              <p v-if="job.location" class="wow fadeIn" :data-wow-delay="(0.1 * index + 0.7) + 's'">{{ job.location }}</p>
              <div class="job-hover-effect"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from 'wowjs';
import {workPositionList} from '@/api/api'
export default {
  name: "JobChance",
  data() {
    return {
      jobs: [
        { title: "销售经理", location: "广东广州市",hot: true },
        { title: "项目经理", location: "广东广州市",hot: true },
        { title: "产品总监", hot: true },
        { title: "产品经理", hot: true },
        { title: "运维工程师",  },
        { title: "售前技术经理", hot: true },
        { title: "商务助理",  },
        { title: "数据处理员" },
      ]
    };
  },
  mounted() {
    // 初始化WOW动画
    var wow = new WOW({
      boxClass: 'wow',      // 动画元素的类名
      animateClass: 'animated', // 触发CSS动画的类名
      offset: 0,            // 距离底部多少像素触发
      mobile: true,         // 是否在移动设备上启用
      live: true,           // 异步加载的内容是否有效
      scrollContainer: null // 可滚动容器的选择器
    });
    wow.init();
    this.initWorkPositionList();
  },
  methods: {
    initWorkPositionList(){
      workPositionList().then(res=>{
        console.log(res)
        this.jobs = res.data
      }).catch(err=>{
        this.$message.error("后台异常"+err)
      })
    },
    goToDetail(job) {
      console.log(job)
      let id = job.id
      this.$router.push({
        path: '/job-detail',
        query: { id }
      })
    }
  }
};
</script>

<style scoped>
/* Banner区域 - 全宽但内容居中 */
.job-banner {
  height: 300px;
  background-image: linear-gradient(to right, rgba(30, 115, 190, 0.8), rgba(0, 0, 0, 0.6)), url("../assets/img/banner_2.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-bottom: 50px;
  position: relative;
  width: 100%;
  transition-delay: 0s;
}

.banner-content {
  text-align: center;
  z-index: 2;
  width: 85%;
  max-width: 1200px;
  padding: 0 15px;
}

.banner-content h1 {
  font-size: 42px;
  font-weight: 600;
  margin-bottom: 15px;
  letter-spacing: 2px;
  transition-delay: 0.2s;
}

.banner-content p {
  font-size: 18px;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
  transition-delay: 0.3s;
}

/* 原有的banner样式可以删除 */
.banner {
  display: none;
}

.section-title {
  text-align: center;
  margin: 40px 0;
  color: #333;
  position: relative;
  padding-bottom: 15px;
  font-size: 32px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: #1e73be;
}

.position-title {
  font-size: 24px;
  margin: 30px 0;
  color: #333;
  font-weight: bold;
}

.job-intro {
  padding: 20px 0;
  max-width: 1200px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.05);
}

.intro-text {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 20px;
  text-align: justify;
}

.contact-info {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-top: 30px;
  margin-bottom: 20px;
  text-align: center;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.contact-info:hover {
  background: #f1f1f1;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}

.contact-info a {
  color: #0066cc;
  text-decoration: none;
  padding: 3px 8px;
  border-radius: 4px;
  position: relative;
  display: inline-block;
  transition: all 0.3s ease;
}

.contact-info a:hover {
  color: #fff;
  background: #0066cc;
  transform: translateY(-2px);
}

.job-list {
  padding: 20px 0 40px;
}

.job-item {
  position: relative;
  padding: 20px;
  margin: 15px 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  cursor: pointer;
  min-height: 120px;
  overflow: hidden;
  border-left: 3px solid transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.job-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  border-left: 3px solid #1e73be;
}

.job-hover-effect {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(45deg, rgba(30, 115, 190, 0.05), rgba(255, 255, 255, 0));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.job-item:hover .job-hover-effect {
  opacity: 1;
}

.hot-tag {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #ff4d4f;
  color: white;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 2px 5px rgba(255, 77, 79, 0.3);
  z-index: 2;
  transition: all 0.3s ease;
}

.hot-tag:hover {
  transform: scale(1.1);
}

.job-item h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
  position: relative;
  z-index: 1;
}

.job-item p {
  font-size: 14px;
  color: #666;
  margin: 0;
  position: relative;
  z-index: 1;
}

/* 媒体查询优化 */
@media screen and (max-width: 992px) {
  .section-title {
    font-size: 28px;
    margin: 30px 0;
  }
  
  .job-intro {
    margin: 0 15px;
  }
}

@media screen and (max-width: 768px) {
  .job-banner {
    height: 200px;
    margin-bottom: 30px;
  }
  
  .banner-content h1 {
    font-size: 32px;
  }
  
  .banner-content p {
    font-size: 16px;
  }
  
  .section-title {
    font-size: 24px;
    margin: 25px 0;
  }
  
  .job-item {
    margin: 10px 0;
    min-height: 100px;
  }
  
  .job-item h3 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  
  .job-item p {
    font-size: 14px;
  }

  .job-intro {
    padding: 20px 15px;
  }

  .job-intro p {
    font-size: 15px;
    line-height: 1.7;
  }
  
  .position-title {
    font-size: 20px;
    margin: 20px 0;
  }
  
  .contact-info {
    font-size: 15px;
    padding: 12px;
    margin-top: 25px;
    margin-bottom: 15px;
  }
}

@media screen and (max-width: 576px) {
  .col-md-3.col-sm-6.col-xs-12 {
    padding: 0 8px;
  }
  
  .row {
    margin: 0 -8px;
  }
  
  .job-item {
    padding: 15px;
    margin: 8px 0;
    min-height: 90px;
  }
}

@media screen and (max-width: 480px) {
  .job-banner {
    height: 180px;
    margin-bottom: 25px;
  }
  
  .banner-content h1 {
    font-size: 28px;
    margin-bottom: 10px;
  }
  
  .banner-content p {
    font-size: 14px;
  }
  
  .section-title {
    font-size: 22px;
    margin: 20px 0;
  }
  
  .job-intro {
    padding: 15px 12px;
  }

  .job-intro p {
    font-size: 14px;
    line-height: 1.6;
  }

  .intro-text {
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 15px;
  }

  .contact-info {
    font-size: 14px;
    padding: 10px;
    margin-top: 20px;
  }
  
  .position-title {
    font-size: 18px;
    margin: 15px 0;
  }
  
  .job-item h3 {
    font-size: 15px;
    margin-bottom: 8px;
  }
  
  .job-item p {
    font-size: 13px;
  }
  
  .hot-tag {
    padding: 2px 8px;
    font-size: 10px;
  }
}

@media screen and (max-width: 375px) {
  .job-banner {
    height: 160px;
    margin-bottom: 20px;
  }
  
  .banner-content h1 {
    font-size: 24px;
  }
  
  .banner-content p {
    font-size: 13px;
  }
  
  .section-title {
    font-size: 20px;
    margin: 15px 0;
  }
  
  .job-intro p {
    font-size: 13px;
    line-height: 1.5;
  }
  
  .contact-info {
    font-size: 13px;
  }
  
  .job-item {
    padding: 12px;
    min-height: 80px;
  }
  
  .job-item h3 {
    font-size: 14px;
    margin-bottom: 6px;
  }
  
  .job-item p {
    font-size: 12px;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/JobChance.vue